export default function serializeForm(form) {
  let field;

  let l;

  const formObject = {};
  if (typeof form === 'object' && form.nodeName === 'FORM') {
    const len = form.elements.length;
    for (let i = 0; i < len; i += 1) {
      field = form.elements[i];
      if (
        field.name &&
        !field.disabled &&
        field.type !== 'file' &&
        field.type !== 'reset' &&
        field.type !== 'submit' &&
        field.type !== 'button'
      ) {
        if (field.type === 'select-multiple') {
          l = form.elements[i].options.length;
          for (let j = 0; j < l; j += 1) {
            // this could not work maybe TODO - check with multiselect
            if (field.options[j].selected) formObject[field.name] = field.options[j].value;
          }
        } else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
          formObject[field.name] = field.value;
        }
      }
    }
  }
  return formObject;
}
